var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherNavigationButtons = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3934 9.92333V6.23083C10.3934 5.55083 9.84252 5 9.16252 5C8.48336 5 7.93252 5.55083 7.93252 6.23083V13.3333L5.72752 12.2017C5.22586 11.9442 4.61502 12.04 4.21669 12.4383C3.68919 12.9658 3.71419 13.8283 4.27086 14.325L8.29169 17.9108C8.59669 18.1825 8.99169 18.3333 9.40086 18.3333H13.2617C14.0425 18.3333 14.7192 17.7908 14.8884 17.0283L15.8792 12.5692C16.0884 11.6292 15.4592 10.7083 14.5075 10.5608L10.3934 9.92333Z",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5358 7.5H14.1667C15.0875 7.5 15.8333 6.75417 15.8333 5.83333V4.16667C15.8333 3.24583 15.0875 2.5 14.1667 2.5H4.16667C3.24583 2.5 2.5 3.24583 2.5 4.16667V5.83333C2.5 6.75417 3.24583 7.5 4.16667 7.5H7.7975",
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherNavigationButtons);
export default ForwardRef;